import { render } from "./GenericImageLayout.vue?vue&type=template&id=bdb2ff88&scoped=true"
import script from "./GenericImageLayout.vue?vue&type=script&lang=js"
export * from "./GenericImageLayout.vue?vue&type=script&lang=js"

import "./GenericImageLayout.vue?vue&type=style&index=0&id=bdb2ff88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb2ff88"]])

export default __exports__